import api from './client';

export interface StateActivity {
  id: number;
  order_id: number;
  mold_id: number | null;
  mold_sbi_id: string | null;
  mold_code: string | null;
  mold_name: string | null;
  mold_number: string | null;
  order_type: string;
  order_status: string;
  priority: number;
  order_created_at: string;
  status: string;
  state_label: string | null;
  order_status_label: string | null;
  workflow_id: number | null;
  workflow_name: string | null;
  workflow_version: number | null;
  assignee_id: number | null;
  assignee: string | null;
  started_by_id: number | null;
  started_by: string | null;
  started_at: string;
  ended_at: string | null;
  duration_minutes: number | null;
  notes: string | null;
  part_numbers: string | null;
}

export interface StateActivityParams {
  from?: string;
  to?: string;
  statuses?: string[];
  orderTypes?: string[];
  assigneeIds?: number[];
  completion?: 'all' | 'completed' | 'open';
  q?: string;
  limit?: number;
  offset?: number;
  sortBy?: 'orderId' | 'moldId' | 'moldCode' | 'moldName' | 'moldNumber' | 'partNumbers' | 'state' | 'startedAt' | 'endedAt' | 'duration' | 'assignee' | 'orderType' | 'priority' | 'orderCreatedAt';
  sortDir?: 'asc' | 'desc';
}

export interface StateActivityResponse {
  items: StateActivity[];
  total: number;
  distinct_molds: number;
  limit: number;
  offset: number;
}

export const stateActivityService = {
  list: (params: StateActivityParams) =>
    api.get<StateActivityResponse>('/state-activities', {
      params,
      // Gin's QueryArray expects repeated keys (statuses=a&statuses=b), not
      // Axios's default bracket form (statuses[]=a&statuses[]=b).
      paramsSerializer: { indexes: null },
    }),
  exportCsv: (params: StateActivityParams) =>
    api.get<Blob>('/state-activities/export.csv', {
      params,
      paramsSerializer: { indexes: null },
      responseType: 'blob',
    }),
};
